import { createFileRoute } from '@tanstack/react-router';
import { AdminActivityScreen } from '@/features/admin/AdminActivityScreen';

type Search = { page?: number; userId?: number };

export const Route = createFileRoute('/_app/admin/activity/')({
  validateSearch: (s: Record<string, unknown>): Search => ({
    page: typeof s.page === 'number' && s.page >= 1 ? Math.floor(s.page) : undefined,
    userId: typeof s.userId === 'number' ? s.userId : undefined,
  }),
  component: () => {
    const { page, userId } = Route.useSearch();
    return <AdminActivityScreen page={page ?? 1} userId={userId ?? null} />;
  },
});
